module.exports = __webpack_public_path__ + "img/logo.07e03d79.png";